<template lang="pug">
.panel-title-right
  .d-flex.flex-column.align-items-end
    .panel-title.text-right(
      v-html='title'
    )
    .panel-subtitle(
      v-html='subtitle'
    )
    //- CustomInputSelect.panel-select(v-model='value' @input='handleInput')
    //-   option(
    //-     v-for='(dateTitle, dateVal) in availableDates'
    //-     :key='dateVal'
    //-     :value='dateVal'
    //-   )
    //-     | {{ dateTitle }}
    CustomDatePicker.panel-select(
      v-if="displayDatePicker"
      :value='value'
      @input='$emit(`input`, $event);'
    )
</template>

<script>
export default {
  props: {
    title: {
      default: '',
    },
    subtitle: {
      default: '',
    },
    value: {
      default: '02-01-2019',
    },
    availableDates: {
      default: () => ({
        '02-01-2019': '2 มกราคม 2562',
        '03-01-2019': '3 มกราคม 2562',
      }),
    },
    displayDatePicker: {
      default: true,
    },
  },
  // watch: {
  //   value(newVal) {
  //     this.$emit(newVal);
  //   },
  // },
  methods: {
    // handleInput(e) {
    //   console.log(e);
    //   this.value = e;
    // },
  },
};
</script>

<style lang="scss">
// .panel-title-right {}
.panel-title {
  font-weight: 300;
  letter-spacing: 1px;
  font-size: 24px;
}
.panel-subtitle {
  font-weight: 300;
  letter-spacing: 1px;
  font-size: 17px;
}
.panel-select {
  // min-width: 190px;
  margin-top: 32px;
  // margin-right: -20px;
  font-size: 19px;
}
</style>
